import * as React from 'react';
import classNames from 'classnames';
import { PagedList } from '../../../../admin/types/pagination';
import './pager.module.scss';

const MAX_PAGES_PER_SIDE = 5;

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  list: PagedList<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onPageUpdate: (page: number) => any;
};

export class Pager extends React.PureComponent<Props> {
  render() {
    const { list, onPageUpdate } = this.props;
    const { totalCount, totalPages, currentPage } = list;
    return (
      <div styleName="pager" className="pager">
        <div styleName="counter" className="total-record-count">
          {totalCount.toLocaleString()}件
        </div>
        <ul styleName="body" className="pagination">
          {currentPage > MAX_PAGES_PER_SIDE + 1 && (
            <li styleName="page-item">
              <a styleName="page-link">...</a>
            </li>
          )}
          {[...Array(totalPages).keys()]
            .map((p) => p + 1)
            .filter((page) => {
              return page >= currentPage - MAX_PAGES_PER_SIDE && page <= currentPage + MAX_PAGES_PER_SIDE;
            })
            .map((page, index) => {
              const active = page === currentPage;
              return (
                <li
                  key={index}
                  styleName={classNames('page-item', { active: active })}
                  onClick={() => !active && onPageUpdate(page)}
                >
                  <a styleName="page-link">{page}</a>
                </li>
              );
            })}
          {totalPages - currentPage > MAX_PAGES_PER_SIDE && (
            <li className="page-item">
              <a styleName="page-link">...</a>
            </li>
          )}
        </ul>
      </div>
    );
  }
}
